import ColumnCard from "./ColumnCard";
import { Text, Link } from "@merge-api/merge-javascript-shared";
import { getBlueprintEditorPath } from "../../../../../../../router/RouterUtils";

interface TypeRowProps {
  candidateTitle?: string;
  integrationID: string;
  stagedBlueprintVersionID: string;
  publishedBlueprintVersionID: string;
}
const TypeRow = ({
  candidateTitle = "Staged",
  integrationID,
  stagedBlueprintVersionID,
  publishedBlueprintVersionID,
}: TypeRowProps) => {
  return (
    <div className="grid items-start grid-cols-3 gap-4 px-5">
      <ColumnCard>
        <Text as="div" variant="h6">
          Type
        </Text>
      </ColumnCard>
      <ColumnCard>
        <div className="space-y-1">
          <Text as="div" variant="h6">
            Published
          </Text>
          <Link
            className="text-sm leading-[18px]"
            target="_blank"
            href={getBlueprintEditorPath(integrationID, publishedBlueprintVersionID)}
          >
            {publishedBlueprintVersionID}
          </Link>
        </div>
      </ColumnCard>
      <ColumnCard>
        <div className="space-y-1">
          <Text as="div" variant="h6">
            {candidateTitle}
          </Text>
          <Link
            className="text-sm leading-[18px]"
            target="_blank"
            href={getBlueprintEditorPath(integrationID, stagedBlueprintVersionID)}
          >
            {stagedBlueprintVersionID}
          </Link>
        </div>
      </ColumnCard>
    </div>
  );
};

export default TypeRow;
